(function() {
  'use strict';

  const STORAGE_KEY = 'qv-grid-density';

  const DESKTOP_CYCLE = [6, 5, 4, 3];
  const MOBILE_CYCLE = [3, 2, 1];

  let toggleBtn;
  let currentDesktopIdx = 0;
  let currentMobileIdx = 0;

  function init() {
    toggleBtn = document.querySelector('[data-grid-cycler]');
    if (!toggleBtn) return;

    const stored = readStored();
    if (stored) {
      currentDesktopIdx = stored.desktopIdx ?? 0;
      currentMobileIdx = stored.mobileIdx ?? 0;
    }

    applyGrid();

    toggleBtn.addEventListener('click', () => {
      currentDesktopIdx = (currentDesktopIdx + 1) % DESKTOP_CYCLE.length;
      currentMobileIdx = (currentMobileIdx + 1) % MOBILE_CYCLE.length;
      applyGrid();
      saveStored();
    });
  }

  function applyGrid() {
    const desktopCols = DESKTOP_CYCLE[currentDesktopIdx];
    const mobileCols = MOBILE_CYCLE[currentMobileIdx];

    // Find ALL grid containers (might be more than one on a page)
    const grids = document.querySelectorAll('.resource-list--grid, [class*="resource-list--grid"]');

    grids.forEach(grid => {
      // Override Horizon's inline CSS variables
      grid.style.setProperty('--resource-list-columns', `repeat(${desktopCols}, 1fr)`);
      grid.style.setProperty('--resource-list-columns-mobile', `repeat(${mobileCols}, 1fr)`);
      grid.style.setProperty('--column-count-mobile', mobileCols);
      grid.style.setProperty('--column-count-desktop', desktopCols);
    });
  }

  function readStored() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveStored() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        desktopIdx: currentDesktopIdx,
        mobileIdx: currentMobileIdx
      }));
    } catch (e) {
      // non-fatal
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();